export { RENDERER_TYPE, numericRenderer } from "./numericRenderer.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/renderers/numericRenderer/index.mjs
// module id = 574
// module chunks = 1